import styles from "./ContactUs.module.css";

export default function ContactUs({ link, email }) {
  return (
    <address className={styles.address}>
      NucleApp Software Private Limited,
      <br />
      Awfis Space Solutions,
      <br />
      Kothaguda Junction,
      <br />
      Kondapur,
      <br />
      Hyderabad,
      <br />
      Telangana,
      <br />
      India - 500084.
      <br />
      {email && (
        <div>
          {" "}
          Email:{" "}
          <a className={styles.link} href={`mailto:${email}`}>
            {email}
          </a>
        </div>
      )}
      <div>
        Website:{" "}
        <a className={styles.link} href={link}>
          {link}
        </a>
      </div>
    </address>
  );
}
